import { render, staticRenderFns } from "./DealerComponent.vue?vue&type=template&id=08ae97c6&scoped=true&"
import script from "./DealerComponent.vue?vue&type=script&lang=js&"
export * from "./DealerComponent.vue?vue&type=script&lang=js&"
import style0 from "./DealerComponent.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./DealerComponent.vue?vue&type=style&index=1&id=08ae97c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae97c6",
  null
  
)

export default component.exports